<template>
  <div class="row mb-2">
    <div class="col-12 col-sm-7">
      <label :for="`drink-${drink.id}`">
        {{drink.name}}
      </label>
    </div>
    <div class="col-5 col-sm-2">{{drink.price | currency}}</div>
    <div class="col-7 col-sm-3">
      <div class="input-group">
        <input :id="`drink-${drink.id}`" type="number" min="0"  class="form-control" v-model="quantity" @input="onChange" inputmode="numeric">
        <div class="input-group-append">
          <span class="input-group-text">{{drink.unit_name}}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      drink: Object,
      handleDrink: Function,
      calculate: Function,
      // 前のプランの画面から引き継いだ数。あれば最初から入れて親に知らせる(「1つ上のプランで見積りを見る」用)
      initialQuantity: { type: Number, default: null }
    },
    data() {
      return {
        quantity: ''
      }
    },
    created() {
      if (this.initialQuantity > 0) {
        this.quantity = this.initialQuantity
        this.onChange()
      }
    },
    methods: {
      onChange() {
        const { name, kind, price, unit_name } = this.drink
        const quantity = this.quantity
        this.$emit('handleDrink', { name, price, kind, unit_name, quantity })
        this.$emit('calculate')
      }
    }
  }
</script>